import { format, formatDistance, isDate } from 'date-fns/esm'
import Cookies from 'js-cookie'

const CONSTANTS = {
  NULL_STR: '--',
  GTS_URL_DATE_FORMAT: 'yyyyMMdd',
  GTS_URL_DATETIME_FORMAT: 'yyyyMMddHHmmss',
  REGEX_ONLY_NUMERIC: /^[0-9]+$/,
  DATE_REGEX:
    /\b(0?[1-9]|1[012])([-/. ])(0?[1-9]|[1|2]\d|3[01])\2(\d{4}|\d{2})\b/, // Matches a date in the m/d/y format with "/", "-", "." and " " as possible delimiters
}

const COUNTRIES_STATES_API_JSON = [
  {
    name: 'UNITED STATES OF AMERICA',
    code: 'US',
    stateProvinceLabel: 'State',
    postalCodeLabel: 'Zip Code',
    postalCodeMask: '00000',
    phoneNumberMask: '(000) 000-0000',
    phoneNumberMaxlength: 14,
    states: [
      {
        name: 'ALABAMA',
        code: 'AL',
      },
      {
        name: 'ALASKA',
        code: 'AK',
      },
      {
        name: 'ARIZONA',
        code: 'AZ',
      },
      {
        name: 'ARKANSAS',
        code: 'AR',
      },
      {
        name: 'CALIFORNIA',
        code: 'CA',
      },
      {
        name: 'COLORADO',
        code: 'CO',
      },
      {
        name: 'CONNECTICUT',
        code: 'CT',
      },
      {
        name: 'DELAWARE',
        code: 'DE',
      },
      {
        name: 'DISTRICT OF COLUMBIA',
        code: 'DC',
      },
      {
        name: 'FLORIDA',
        code: 'FL',
      },
      {
        name: 'GEORGIA',
        code: 'GA',
      },
      {
        name: 'HAWAII',
        code: 'HI',
      },
      {
        name: 'IDAHO',
        code: 'ID',
      },
      {
        name: 'ILLINOIS',
        code: 'IL',
      },
      {
        name: 'INDIANA',
        code: 'IN',
      },
      {
        name: 'IOWA',
        code: 'IA',
      },
      {
        name: 'KANSAS',
        code: 'KS',
      },
      {
        name: 'KENTUCKY',
        code: 'KY',
      },
      {
        name: 'LOUISIANA',
        code: 'LA',
      },
      {
        name: 'MAINE',
        code: 'ME',
      },
      {
        name: 'MARYLAND',
        code: 'MD',
      },
      {
        name: 'MASSACHUSETTS',
        code: 'MA',
      },
      {
        name: 'MICHIGAN',
        code: 'MI',
      },
      {
        name: 'MINNESOTA',
        code: 'MN',
      },
      {
        name: 'MISSISSIPPI',
        code: 'MS',
      },
      {
        name: 'MISSOURI',
        code: 'MO',
      },
      {
        name: 'MONTANA',
        code: 'MT',
      },
      {
        name: 'NEBRASKA',
        code: 'NE',
      },
      {
        name: 'NEVADA',
        code: 'NV',
      },
      {
        name: 'NEW HAMPSHIRE',
        code: 'NH',
      },
      {
        name: 'NEW JERSEY',
        code: 'NJ',
      },
      {
        name: 'NEW MEXICO',
        code: 'NM',
      },
      {
        name: 'NEW YORK',
        code: 'NY',
      },
      {
        name: 'NORTH CAROLINA',
        code: 'NC',
      },
      {
        name: 'NORTH DAKOTA',
        code: 'ND',
      },
      {
        name: 'OHIO',
        code: 'OH',
      },
      {
        name: 'OKLAHOMA',
        code: 'OK',
      },
      {
        name: 'OREGON',
        code: 'OR',
      },
      {
        name: 'PENNSYLVANIA',
        code: 'PA',
      },
      {
        name: 'RHODE ISLAND',
        code: 'RI',
      },
      {
        name: 'SOUTH CAROLINA',
        code: 'SC',
      },
      {
        name: 'SOUTH DAKOTA',
        code: 'SD',
      },
      {
        name: 'TENNESSEE',
        code: 'TN',
      },
      {
        name: 'TEXAS',
        code: 'TX',
      },
      {
        name: 'UTAH',
        code: 'UT',
      },
      {
        name: 'VERMONT',
        code: 'VT',
      },
      {
        name: 'VIRGINIA',
        code: 'VA',
      },
      {
        name: 'WASHINGTON',
        code: 'WA',
      },
      {
        name: 'WEST VIRGINIA',
        code: 'WV',
      },
      {
        name: 'WISCONSIN',
        code: 'WI',
      },
      {
        name: 'WYOMING',
        code: 'WY',
      },
    ],
  },
  {
    name: 'CANADA',
    code: 'CA',
    stateProvinceLabel: 'Province',
    postalCodeLabel: 'Postal Code',
    postalCodeMask: 'S0S 0S0',
    phoneNumberMask: '(000) 000-0000',
    phoneNumberMaxlength: 14,
    states: [
      {
        name: 'ALBERTA',
        code: 'AB',
      },
      {
        name: 'BRITISH COLUMBIA',
        code: 'BC',
      },
      {
        name: 'MANITOBA',
        code: 'MB',
      },
      {
        name: 'NEW BRUNSWICK',
        code: 'NB',
      },
      {
        name: 'NEWFOUNDLAND',
        code: 'NF',
      },
      {
        name: 'NORTHWEST TERRITORIES',
        code: 'NT',
      },
      {
        name: 'NOVA SCOTIA',
        code: 'NS',
      },
      {
        name: 'NUNAVUT',
        code: 'NU',
      },
      {
        name: 'ONTARIO',
        code: 'ON',
      },
      {
        name: 'PRINCE EDWARD ISLAND',
        code: 'PE',
      },
      {
        name: 'QUEBEC',
        code: 'QC',
      },
      {
        name: 'SASKATCHEVAN',
        code: 'SK',
      },
      {
        name: 'YUKON',
        code: 'YT',
      },
    ],
  },
  {
    name: 'AFGHANISTAN',
    code: 'AF',
  },
  {
    name: 'ALBANIA',
    code: 'AL',
  },
  {
    name: 'ALGERIA',
    code: 'DZ',
  },
  {
    name: 'AMERICAN SAMOA',
    code: 'AS',
  },
  {
    name: 'ANDORRA',
    code: 'AD',
  },
  {
    name: 'ANGOLA',
    code: 'AO',
  },
  {
    name: 'ANGUILLA',
    code: 'AI',
  },
  {
    name: 'ANTIGUA AND BARBUDA',
    code: 'AG',
  },
  {
    name: 'ARGENTINA',
    code: 'AR',
  },
  {
    name: 'ARMENIA',
    code: 'AM',
  },
  {
    name: 'ARUBA',
    code: 'AW',
  },
  {
    name: 'AUSTRALIA',
    code: 'AU',
  },
  {
    name: 'AUSTRIA',
    code: 'AT',
  },
  {
    name: 'AZERBAIJAN',
    code: 'AZ',
  },
  {
    name: 'BAHAMAS',
    code: 'BS',
  },
  {
    name: 'BAHRAIN',
    code: 'BH',
  },
  {
    name: 'BANGLADESH',
    code: 'BD',
  },
  {
    name: 'BARBADOS',
    code: 'BB',
  },
  {
    name: 'BELARUS',
    code: 'BY',
  },
  {
    name: 'BELGIUM',
    code: 'BE',
  },
  {
    name: 'BELIZE',
    code: 'BZ',
  },
  {
    name: 'BENIN',
    code: 'BJ',
  },
  {
    name: 'BERMUDA',
    code: 'BM',
  },
  {
    name: 'BHUTAN',
    code: 'BT',
  },
  {
    name: 'BOLIVIA (PLURINATIONAL STATE OF)',
    code: 'BO',
  },
  {
    name: 'BOSNIA AND HERZEGOVINA',
    code: 'BA',
  },
  {
    name: 'BOTSWANA',
    code: 'BW',
  },
  {
    name: 'BRAZIL',
    code: 'BR',
  },
  {
    name: 'BRUNEI DARUSSALAM',
    code: 'BN',
  },
  {
    name: 'BULGARIA',
    code: 'BG',
  },
  {
    name: 'BURKINA FASO',
    code: 'BF',
  },
  {
    name: 'BURUNDI',
    code: 'BI',
  },
  {
    name: 'CABO VERDE',
    code: 'CV',
  },
  {
    name: 'CAMBODIA',
    code: 'KH',
  },
  {
    name: 'CAMEROON',
    code: 'CM',
  },
  {
    name: 'CAYMAN ISLANDS',
    code: 'KY',
  },
  {
    name: 'CENTRAL AFRICAN REPUBLIC',
    code: 'CF',
  },
  {
    name: 'CHAD',
    code: 'TD',
  },
  {
    name: 'CHILE',
    code: 'CL',
  },
  {
    name: 'CHINA',
    code: 'CN',
  },
  {
    name: 'COLOMBIA',
    code: 'CO',
  },
  {
    name: 'COMOROS',
    code: 'KM',
  },
  {
    name: 'CONGO',
    code: 'CG',
  },
  {
    name: 'CONGO, DEMOCRATIC REPUBLIC OF THE',
    code: 'CD',
  },
  {
    name: 'COOK ISLANDS',
    code: 'CK',
  },
  {
    name: 'COSTA RICA',
    code: 'CR',
  },
  {
    name: "CÔTE D'IVOIRE",
    code: 'CI',
  },
  {
    name: 'CROATIA',
    code: 'HR',
  },
  {
    name: 'CUBA',
    code: 'CU',
  },
  {
    name: 'CURAÇAO',
    code: 'CW',
  },
  {
    name: 'CYPRUS',
    code: 'CY',
  },
  {
    name: 'CZECHIA',
    code: 'CZ',
  },
  {
    name: 'DENMARK',
    code: 'DK',
  },
  {
    name: 'DJIBOUTI',
    code: 'DJ',
  },
  {
    name: 'DOMINICA',
    code: 'DM',
  },
  {
    name: 'DOMINICAN REPUBLIC',
    code: 'DO',
  },
  {
    name: 'ECUADOR',
    code: 'EC',
  },
  {
    name: 'EGYPT',
    code: 'EG',
  },
  {
    name: 'EL SALVADOR',
    code: 'SV',
  },
  {
    name: 'EQUATORIAL GUINEA',
    code: 'GQ',
  },
  {
    name: 'ERITREA',
    code: 'ER',
  },
  {
    name: 'ESTONIA',
    code: 'EE',
  },
  {
    name: 'ESWATINI',
    code: 'SZ',
  },
  {
    name: 'ETHIOPIA',
    code: 'ET',
  },
  {
    name: 'FIJI',
    code: 'FJ',
  },
  {
    name: 'FINLAND',
    code: 'FI',
  },
  {
    name: 'FRANCE',
    code: 'FR',
  },
  {
    name: 'GABON',
    code: 'GA',
  },
  {
    name: 'GAMBIA',
    code: 'GM',
  },
  {
    name: 'GEORGIA',
    code: 'GE',
  },
  {
    name: 'GERMANY',
    code: 'DE',
  },
  {
    name: 'GHANA',
    code: 'GH',
  },
  {
    name: 'GIBRALTAR',
    code: 'GI',
  },
  {
    name: 'GREECE',
    code: 'GR',
  },
  {
    name: 'GREENLAND',
    code: 'GL',
  },
  {
    name: 'GRENADA',
    code: 'GD',
  },
  {
    name: 'GUAM',
    code: 'GU',
  },
  {
    name: 'GUATEMALA',
    code: 'GT',
  },
  {
    name: 'GUERNSEY',
    code: 'GG',
  },
  {
    name: 'GUINEA',
    code: 'GN',
  },
  {
    name: 'GUINEA-BISSAU',
    code: 'GW',
  },
  {
    name: 'GUYANA',
    code: 'GY',
  },
  {
    name: 'HAITI',
    code: 'HT',
  },
  {
    name: 'HOLY SEE',
    code: 'VA',
  },
  {
    name: 'HONDURAS',
    code: 'HN',
  },
  {
    name: 'HONG KONG',
    code: 'HK',
  },
  {
    name: 'HUNGARY',
    code: 'HU',
  },
  {
    name: 'ICELAND',
    code: 'IS',
  },
  {
    name: 'INDIA',
    code: 'IN',
  },
  {
    name: 'INDONESIA',
    code: 'ID',
  },
  {
    name: 'IRAN (ISLAMIC REPUBLIC OF)',
    code: 'IR',
  },
  {
    name: 'IRAQ',
    code: 'IQ',
  },
  {
    name: 'IRELAND',
    code: 'IE',
  },
  {
    name: 'ISLE OF MAN',
    code: 'IM',
  },
  {
    name: 'ISRAEL',
    code: 'IL',
  },
  {
    name: 'ITALY',
    code: 'IT',
  },
  {
    name: 'JAMAICA',
    code: 'JM',
  },
  {
    name: 'JAPAN',
    code: 'JP',
  },
  {
    name: 'JERSEY',
    code: 'JE',
  },
  {
    name: 'JORDAN',
    code: 'JO',
  },
  {
    name: 'KAZAKHSTAN',
    code: 'KZ',
  },
  {
    name: 'KENYA',
    code: 'KE',
  },
  {
    name: 'KIRIBATI',
    code: 'KI',
  },
  {
    name: "KOREA (THE DEMOCRATIC PEOPLE'S REPUBLIC OF)",
    code: 'KP',
  },
  {
    name: 'KOREA, REPUBLIC OF',
    code: 'KR',
  },
  {
    name: 'KOSOVO',
    code: 'XK',
  },
  {
    name: 'KUWAIT',
    code: 'KW',
  },
  {
    name: 'KYRGYZSTAN',
    code: 'KG',
  },
  {
    name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    code: 'LA',
  },
  {
    name: 'LATVIA',
    code: 'LV',
  },
  {
    name: 'LEBANON',
    code: 'LB',
  },
  {
    name: 'LESOTHO',
    code: 'LS',
  },
  {
    name: 'LIBERIA',
    code: 'LR',
  },
  {
    name: 'LIBYA',
    code: 'LY',
  },
  {
    name: 'LIECHTENSTEIN',
    code: 'LI',
  },
  {
    name: 'LITHUANIA',
    code: 'LT',
  },
  {
    name: 'LUXEMBOURG',
    code: 'LU',
  },
  {
    name: 'MACAO',
    code: 'MO',
  },
  {
    name: 'MADAGASCAR',
    code: 'MG',
  },
  {
    name: 'MALAWI',
    code: 'MW',
  },
  {
    name: 'MALAYSIA',
    code: 'MY',
  },
  {
    name: 'MALDIVES',
    code: 'MV',
  },
  {
    name: 'MALI',
    code: 'ML',
  },
  {
    name: 'MALTA',
    code: 'MT',
  },
  {
    name: 'MARSHALL ISLANDS',
    code: 'MH',
  },
  {
    name: 'MAURITANIA',
    code: 'MR',
  },
  {
    name: 'MAURITIUS',
    code: 'MU',
  },
  {
    name: 'MEXICO',
    code: 'MX',
  },
  {
    name: 'MICRONESIA (FEDERATED STATES OF)',
    code: 'FM',
  },
  {
    name: 'MOLDOVA, REPUBLIC OF',
    code: 'MD',
  },
  {
    name: 'MONACO',
    code: 'MC',
  },
  {
    name: 'MONGOLIA',
    code: 'MN',
  },
  {
    name: 'MONTENEGRO',
    code: 'ME',
  },
  {
    name: 'MONTSERRAT',
    code: 'MS',
  },
  {
    name: 'MOROCCO',
    code: 'MA',
  },
  {
    name: 'MOZAMBIQUE',
    code: 'MZ',
  },
  {
    name: 'MYANMAR',
    code: 'MM',
  },
  {
    name: 'NAMIBIA',
    code: 'NA',
  },
  {
    name: 'NAURU',
    code: 'NR',
  },
  {
    name: 'NEPAL',
    code: 'NP',
  },
  {
    name: 'NETHERLANDS',
    code: 'NL',
  },
  {
    name: 'NEW ZEALAND',
    code: 'NZ',
  },
  {
    name: 'NICARAGUA',
    code: 'NI',
  },
  {
    name: 'NIGER',
    code: 'NE',
  },
  {
    name: 'NIGERIA',
    code: 'NG',
  },
  {
    name: 'NIUE',
    code: 'NU',
  },
  {
    name: 'NORTH MACEDONIA',
    code: 'MK',
  },
  {
    name: 'NORTHERN MARIANA ISLANDS',
    code: 'MP',
  },
  {
    name: 'NORWAY',
    code: 'NO',
  },
  {
    name: 'OMAN',
    code: 'OM',
  },
  {
    name: 'PAKISTAN',
    code: 'PK',
  },
  {
    name: 'PALAU',
    code: 'PW',
  },
  {
    name: 'PALESTINE, STATE OF',
    code: 'PS',
  },
  {
    name: 'PANAMA',
    code: 'PA',
  },
  {
    name: 'PAPUA NEW GUINEA',
    code: 'PG',
  },
  {
    name: 'PARAGUAY',
    code: 'PY',
  },
  {
    name: 'PERU',
    code: 'PE',
  },
  {
    name: 'PHILIPPINES',
    code: 'PH',
  },
  {
    name: 'POLAND',
    code: 'PL',
  },
  {
    name: 'PORTUGAL',
    code: 'PT',
  },
  {
    name: 'PUERTO RICO',
    code: 'PR',
  },
  {
    name: 'QATAR',
    code: 'QA',
  },
  {
    name: 'ROMANIA',
    code: 'RO',
  },
  {
    name: 'RUSSIAN FEDERATION',
    code: 'RU',
  },
  {
    name: 'RWANDA',
    code: 'RW',
  },
  {
    name: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
    code: 'SH',
  },
  {
    name: 'SAINT KITTS AND NEVIS',
    code: 'KN',
  },
  {
    name: 'SAINT LUCIA',
    code: 'LC',
  },
  {
    name: 'SAINT VINCENT AND THE GRENADINES',
    code: 'VC',
  },
  {
    name: 'SAMOA',
    code: 'WS',
  },
  {
    name: 'SAN MARINO',
    code: 'SM',
  },
  {
    name: 'SAO TOME AND PRINCIPE',
    code: 'ST',
  },
  {
    name: 'SAUDI ARABIA',
    code: 'SA',
  },
  {
    name: 'SENEGAL',
    code: 'SN',
  },
  {
    name: 'SERBIA',
    code: 'RS',
  },
  {
    name: 'SEYCHELLES',
    code: 'SC',
  },
  {
    name: 'SIERRA LEONE',
    code: 'SL',
  },
  {
    name: 'SINGAPORE',
    code: 'SG',
  },
  {
    name: 'SINT MAARTEN (DUTCH PART)',
    code: 'SX',
  },
  {
    name: 'SLOVAKIA',
    code: 'SK',
  },
  {
    name: 'SLOVENIA',
    code: 'SI',
  },
  {
    name: 'SOLOMON ISLANDS',
    code: 'SB',
  },
  {
    name: 'SOMALIA',
    code: 'SO',
  },
  {
    name: 'SOUTH AFRICA',
    code: 'ZA',
  },
  {
    name: 'SOUTH SUDAN',
    code: 'SS',
  },
  {
    name: 'SPAIN',
    code: 'ES',
  },
  {
    name: 'SPAIN (NAVARRA)',
    code: 'ES-NC',
  },
  {
    name: 'SRI LANKA',
    code: 'LK',
  },
  {
    name: 'SUDAN',
    code: 'SD',
  },
  {
    name: 'SURINAME',
    code: 'SR',
  },
  {
    name: 'SWEDEN',
    code: 'SE',
  },
  {
    name: 'SWITZERLAND',
    code: 'CH',
  },
  {
    name: 'SYRIAN ARAB REPUBLIC',
    code: 'SY',
  },
  {
    name: 'TAIWAN, PROVINCE OF CHINA',
    code: 'TW',
  },
  {
    name: 'TAJIKISTAN',
    code: 'TJ',
  },
  {
    name: 'TANZANIA, UNITED REPUBLIC OF',
    code: 'TZ',
  },
  {
    name: 'THAILAND',
    code: 'TH',
  },
  {
    name: 'TIMOR-LESTE',
    code: 'TL',
  },
  {
    name: 'TOGO',
    code: 'TG',
  },
  {
    name: 'TOKELAU',
    code: 'TK',
  },
  {
    name: 'TONGA',
    code: 'TO',
  },
  {
    name: 'TRINIDAD AND TOBAGO',
    code: 'TT',
  },
  {
    name: 'TUNISIA',
    code: 'TN',
  },
  {
    name: 'TURKEY',
    code: 'TR',
  },
  {
    name: 'TURKMENISTAN',
    code: 'TM',
  },
  {
    name: 'TURKS AND CAICOS ISLANDS',
    code: 'TC',
  },
  {
    name: 'TUVALU',
    code: 'TV',
  },
  {
    name: 'UGANDA',
    code: 'UG',
  },
  {
    name: 'UKRAINE',
    code: 'UA',
  },
  {
    name: 'UNITED ARAB EMIRATES',
    code: 'AE',
  },
  {
    name: 'UNITED KINGDOM',
    code: 'GB',
  },
  {
    name: 'URUGUAY',
    code: 'UY',
  },
  {
    name: 'UZBEKISTAN',
    code: 'UZ',
  },
  {
    name: 'VANUATU',
    code: 'VU',
  },
  {
    name: 'VENEZUELA (BOLIVARIAN REPUBLIC OF)',
    code: 'VE',
  },
  {
    name: 'VIET NAM',
    code: 'VN',
  },
  {
    name: 'VIRGIN ISLANDS (BRITISH)',
    code: 'VG',
  },
  {
    name: 'VIRGIN ISLANDS (U.S.)',
    code: 'VI',
  },
  {
    name: 'WALLIS AND FUTUNA',
    code: 'WF',
  },
  {
    name: 'YEMEN',
    code: 'YE',
  },
  {
    name: 'ZAMBIA',
    code: 'ZM',
  },
  {
    name: 'ZIMBABWE',
    code: 'ZW',
  },
]

const utils = {
  DATAGRID_CUSTOM_PADDING_OFFSET: 30,
  MIN_DATAGRID_HEIGHT: 300,
  DATAGRID_SUMMARY_FORMAT: '{0} records',
  GTS_SHORT_DATE_FORMAT: 'd MMM yyyy',
  GTS_STANDARD_FORMAT: 'MM/dd/yyyy',
  GTS_DATETIME_FORMAT_FILENAME: 'd_MMM_yyyy__HH_mm_ss',
  NULL_STR: CONSTANTS.NULL_STR,
  NULL_DATETIME_STR: '1900-01-01T00:00:00',
  NULL_DATETIME_STR_2: '1800-01-01T00:00:00',
  NULLABLE_DATETIME_STR: '0001-01-01T00:00:00',
  NULL_DATETIME_PART: 'T00:00:00',
  US_ZIPCODE_PATTERN: '^\\d{5}(\\-?\\d{4})?$',
  CA_ZIPCODE_PATTERN: '/^[ABCEGHJ-NPRSTVXY]\\d[A-Z] \\d[A-Z]\\d$/i',
  PHONE_PATTERN: '\\(\\d{3}\\) \\d{3}\\-\\d{4}',
  ACCOUNT_NUM_PATTERN: '^[\\w\\s\\.\\-]+[,\\w\\s\\.\\-]*$',
  MIDDLE_DOT_ASCII: '&#183;',
  DEFAULT_MIME_TYPE: 'application/octet-stream',
  EXCEL_MIME_TYPE:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PDF_MIME_TYPE: 'application/pdf',
  EXPORT_ALL_HOVER_TEXT: { exportAll: 'Export to Excel' },
  ZIP_MIME_TYPE: 'application/zip',
  JPEG_MIME_TYPE: 'image/jpeg',
  PNG_MIME_TYPE: 'image/png',
  DOC_TYPES: {
    PDF: 'pdf',
    ZIP: 'zip',
    DOCX: 'docx',
    XLSX: 'xlsx',
    XLS: 'xls',
  },
  ICON_UNAVAILABLE: `<i class="tiny grey minus icon"></i>`,
  ICON_LOADING: `<i class="small spinner loading icon"></i>`,
  FORM_SAVED_TIMEOUT: 2000,
  COUNTRIES: COUNTRIES_STATES_API_JSON,
  getCookieId() {
    let _textBase64CombinedCipher = btoa(
      __APPLICATION_ID + __API_VERSION + __ENV,
    )

    // From API
    _textBase64CombinedCipher = _textBase64CombinedCipher.split('=')[0] // Remove any trailing '='s
    // _textBase64CombinedCipher = _textBase64CombinedCipher.replaceAll('+', '-') // 62nd char of encoding
    // _textBase64CombinedCipher = _textBase64CombinedCipher.replaceAll('/', '_') // 63rd char of encoding
    _textBase64CombinedCipher = _textBase64CombinedCipher.replace(/\+/g, '-') // 62nd char of encoding
    _textBase64CombinedCipher = _textBase64CombinedCipher.replace(/\//g, '_') // 63rd char of encoding

    return _textBase64CombinedCipher
  },
  getXSRFTokenFromCookie() {
    const cookieId = this.getCookieId()
    const XSRFCookieName = `XSRF-TOKEN_${cookieId}`

    return Cookies.get(XSRFCookieName)
  },
  setXSRFRequestHeader(jqXHR) {
    let xsrfToken = this.getXSRFTokenFromCookie()
    if (xsrfToken) jqXHR.setRequestHeader('X-XSRF-TOKEN', xsrfToken)
  },
  getParticipantNumberFromInput(fieldValue) {
    if (!fieldValue) return fieldValue

    // Check if number is numeric, if so parse and make string again
    let _participantNumber = isNaN(fieldValue)
      ? fieldValue
      : this.parseInt(fieldValue).toString()

    return _participantNumber
  },
  parsePercentages: (num) => {
    if (!num) return null
    let _number = parseFloat(num)

    if (isNaN(_number)) return null

    if (_number >= 0 && _number < 1) _number = _number * 100

    let pct = Number.isInteger(_number) ? _number : _number.toFixed(3)

    return pct + '%'
  },
  parseInt(num) {
    return parseInt(num, 10)
  },
  parseDateTime: (datetime) => {
    if (!datetime) return

    let d = new Date(datetime)

    var m_names = new Array(
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    )

    let curr_date = d.getDate()
    let curr_month = d.getMonth()
    let curr_year = d.getFullYear()

    return curr_date + ' ' + m_names[curr_month].toUpperCase() + ' ' + curr_year
  },
  formatSummaryOnCellPrepared: function (e) {
    if (e.rowType == 'totalFooter') {
      var summaryItem = $(e.cellElement).find('.dx-datagrid-summary-item')
      if (summaryItem.length > 0) {
        e.cellElement.colSpan = '2'
        summaryItem.html(
          '<i class="blue info circle icon"></i> ' + summaryItem[0].innerHTML,
        )
      }
    }
  },
  customExporter: function (cols, rows) {
    // Remove the last row - which is the totalFooter - where the summary is
    // 99.9% this is the last row so we use .pop method
    rows.pop()
  },
  timeSince(strDate, stringIfNullOrEmpty) {
    if (!strDate) return stringIfNullOrEmpty || this.ICON_UNAVAILABLE
    return formatDistance(new Date(strDate), new Date(), {
      addSuffix: true,
    })
  },
  formatDate: function (
    datetime,
    strFormat,
    includeTime = false,
    includeSecs = false,
  ) {
    // first check if strDate is valid date
    if (this.isDateNull(datetime)) return null

    let _datetime = datetime

    if (typeof datetime === 'string') {
      _datetime = datetime.match(/^\d{4}-\d{2}-\d{2}$/)
        ? new Date(
            datetime.split('-')[0],
            datetime.split('-')[1] - 1,
            datetime.split('-')[2],
          )
        : new Date(datetime)
    }

    let _formattedDate = format(
      _datetime,
      strFormat ||
        (includeTime
          ? `d MMM yyyy h:mm${includeSecs ? ':ss' : ''} a`
          : this.GTS_SHORT_DATE_FORMAT),
    ).toUpperCase()

    return _formattedDate
  },
  formatDateOrDash(datetime, strFormat, includeTime = false) {
    return this.isDateNull(datetime)
      ? this.ICON_UNAVAILABLE
      : this.formatDate(datetime, strFormat, includeTime)
  },
  isDateNull(datetime) {
    if (!datetime) return true

    let isDateNull =
      typeof datetime === 'string'
        ? datetime === this.NULL_DATETIME_STR ||
          datetime === this.NULL_DATETIME_STR_2
        : datetime.getTime() === new Date(this.NULL_DATETIME_STR).getTime() ||
          datetime.getTime() === new Date(this.NULL_DATETIME_STR_2).getTime()

    return isDateNull
  },
  formatDateURL: function (datetime, dateOnly) {
    if (!datetime) return null
    if (!isDate(datetime)) datetime = new Date(datetime)

    return datetime
      ? format(
          datetime,
          dateOnly
            ? CONSTANTS.GTS_URL_DATE_FORMAT
            : CONSTANTS.GTS_URL_DATETIME_FORMAT,
        )
      : null
  },
  unformatDateURL: function (date, dateOnly = true) {
    if (!date) return null
    if (isDate(date)) return date

    const yyyy = this.parseInt(date.substring(0, 4))
    const MM = this.parseInt(date.substring(4, 6)) - 1
    const dd = this.parseInt(date.substring(6, 8))

    let hh = 0,
      mm = 0,
      ss = 0

    if (!dateOnly) {
      hh = this.parseInt(date.substring(8, 10))
      mm = this.parseInt(date.substring(10, 12))
      ss = this.parseInt(date.substring(12, 14))
    }

    const dt = new Date(yyyy, MM, dd, hh, mm, ss)

    return dt
  },
  formatNumber: function (number) {
    if (number === null || typeof number === 'undefined') return null
    let _number = parseFloat(number)
    return _number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  },
  formatShares: function (number) {
    return this.formatNumber(number)
  },
  formatMoney: function (number) {
    if (number === null || typeof number === 'undefined') return null
    let _number = parseFloat(number)
    return _number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  },
  customizeGridTotalItemsText({ value }) {
    let _value = parseFloat(value)
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    let _text = `${_value} record${value === 0 || value > 1 ? 's' : ''}`
    return _text
  },
  /** configure a specific property with time ago formatting - devextreme grid */
  customizeDTCellWithTimeAgo(cellElement, cellInfo) {
    let formattedValue = this.timeSince(cellInfo.value)
    $(
      `<span title="${cellInfo.displayValue}">${formattedValue}</span>`,
    ).appendTo(cellElement)
  },
  customizeDTFull(cellElement, cellInfo) {
    cellElement.innerHTML = this.formatDateOrDash(cellInfo.value, null, true)
  },
  formatDateForDataGrid(cellElement, cellInfo) {
    let formattedValue = this.formatDateOrDash(cellInfo.value)
    $(cellElement).html(formattedValue)
  },
  customizeNullValues(cellElement, cellInfo) {
    let formattedValue = cellInfo.value || this.ICON_UNAVAILABLE
    $(cellElement).html(formattedValue)
  },
  getNumAsTwoDigits: function (n) {
    return (n < 10 ? '0' : '') + n
  },
  getAvailableGridHeight: function (
    selector,
    addPadding = true,
    customPaddingOffset = this.DATAGRID_CUSTOM_PADDING_OFFSET,
  ) {
    let padding = addPadding ? customPaddingOffset : 0

    // safeguard for fast navigation using back buttons when callbacks are being flushed
    if ($(selector).length === 0) return 0

    let height = $(window).height() - $(selector).offset().top - padding
    let finalHeight =
      height >= this.MIN_DATAGRID_HEIGHT ? height : this.MIN_DATAGRID_HEIGHT

    return finalHeight
  },
  getUnique: function (array) {
    return array.filter((value, index, self) => self.indexOf(value) === index)
  },
  returnFileSize: function (number) {
    if (number < 1024) {
      return number + 'bytes'
    } else if (number > 1024 && number < 1048576) {
      return (number / 1024).toFixed(1) + 'KB'
    } else if (number > 1048576) {
      return (number / 1048576).toFixed(1) + 'MB'
    }
  },
  popupWindow(url, title, w = 1060, h = 600) {
    var left = screen.width / 2 - w / 2
    var top = screen.height / 2 - h / 2
    return window.open(
      url,
      title,
      'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=' +
        w +
        ', height=' +
        h +
        ', top=' +
        top +
        ', left=' +
        left,
    )
  },
  getNofFieldsAsString(array) {
    let visibleFields = array.filter((item) => !item.isHidden)

    return [
      '',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
    ][this.parseInt(visibleFields.length - 1)]
  },
  clearServerSideErrors($el) {
    let $field = $(`#${$el.target.name}`)
    if ($field.popup('exists')) {
      $field.popup('destroy').closest('.field')
    }
  },
  camelCaseToRegular(str) {
    return (
      str
        .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
        .replace(/^./, function (_str) {
          return _str.toUpperCase()
        })
    )
  },
  stopPropagation() {
    // Dummy click handler
    return false
  },
  copyToClipboard: (str) => {
    // Borrowed from: hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  },
  downloadZipFile(url, payload, successCallback, errorCallback) {
    this.downloadFileFromJSON(
      url,
      payload,
      this.ZIP_MIME_TYPE,
      successCallback,
      errorCallback,
    )
  },
  downloadExcelFile(url, successCallback, errorCallback) {
    this.downloadFileFromJSON(
      url,
      null,
      this.EXCEL_MIME_TYPE,
      successCallback,
      errorCallback,
    )
  },
  downloadFileFromJSON(url, payload, mimeType, successCallback, errorCallback) {
    window.shouldSuppressOBU = true

    let utils = this
    let _config = {
      url,
    }

    if (payload) {
      Object.assign(_config, {
        method: 'POST',
        contentType: 'application/json',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        data: JSON.stringify(payload),
      })
    } else {
      Object.assign(_config, {
        method: 'GET',
      })
    }

    $.ajax(_config)
      .done(function (json, textStatus, jqXHR) {
        utils.processFileData(json.data, mimeType, json.fileName, true)
        if (successCallback) successCallback(json, textStatus, jqXHR)
      })
      .fail(function (jqXHR, statusText, error) {
        if (errorCallback) errorCallback(jqXHR, statusText, error)
        else alert(jqXHR.responseText)
      })

    setTimeout(() => {
      window.shouldSuppressOBU = false
    }, 0)
  },
  downloadFileRaw(url, mimeType, fileName, successCallback, errorCallback) {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.responseType = 'arraybuffer'

    xhr.withCredentials = true
    xhr.setRequestHeader('x-api-version', __API_VERSION)
    xhr.setRequestHeader('x-app-id', __APPLICATION_ID)
    this.setXSRFRequestHeader(xhr)

    xhr.onload = function () {
      if (xhr.status != 200) {
        // analyze HTTP status of the response
        if (errorCallback) errorCallback(this)
      } else {
        var arrayBuffer = xhr.response // Note: not xhr.responseText
        if (arrayBuffer) {
          utils.processFileData(arrayBuffer, mimeType, fileName, false)
          if (successCallback) successCallback(this)
        }
      }
    }

    try {
      xhr.send(null)
    } catch {
      if (errorCallback) errorCallback(xhr)
    }
  },
  processFileData(response, mimeType, fileName, isBase64) {
    let _blob = this.convertBinaryToBlob(response, mimeType, fileName, isBase64)
    // console.log('processFileData: ' + fileName)
    // for microsoft IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(_blob, fileName)
    } else {
      let _link = document.createElement('a')
      _link.href = window.URL.createObjectURL(_blob)
      _link.download = fileName
      document.body.appendChild(_link)
      _link.click()
      window.URL.revokeObjectURL(_link.href)
      document.body.removeChild(_link)
    }
  },
  convertBinaryToBlob(response, mimeType, fileName, isBase64) {
    // https://stackoverflow.com/questions/34993292/how-to-save-xlsx-data-to-file-as-a-blob
    var buf = null
    if (isBase64) {
      let _response = atob(response)
      buf = new ArrayBuffer(_response.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i != _response.length; ++i)
        view[i] = _response.charCodeAt(i) & 0xff
    } else {
      buf = new Uint8Array(response)
    }

    // IE does not support File constructor
    var blob = null
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      blob = new Blob([buf], {
        type: mimeType,
      })
      // Manually inserting a property called 'name' to mimic new File() for IE11
      blob.name = fileName
    } else {
      // MIME TYPE BREAKS in Firefox where it uses that instead of filename
      // since it is optional, I am taking it out as of Feb 2021 ONLY for .xls legacy excel files;
      if (fileName.split('.')[1] === 'xls') {
        blob = new File([buf], fileName)
      } else {
        blob = new File([buf], fileName, {
          type: mimeType,
        })
      }
    }

    return blob
  },
  printWindow() {
    window.print()
  },
  getAPIErrorMessageHTML(jqXHR) {
    return jqXHR.responseJSON && jqXHR.responseJSON.message
      ? jqXHR.responseJSON.message +
          (jqXHR.responseJSON.referenceNumber
            ? '&nbsp;&nbsp; | &nbsp;&nbsp;Ref #: ' +
              jqXHR.responseJSON.referenceNumber
            : '')
      : jqXHR.statusText
        ? jqXHR.statusText + '&nbsp;&nbsp; | &nbsp;&nbsp;Code: ' + jqXHR.status
        : 'Internal Server Error*' // + '&nbsp;&nbsp; | &nbsp;&nbsp;Code: ' + jqXHR.status
  },
  processValidationFormFieldsErrors(jqXHR) {
    let _result = false

    let fieldsWithErrors = JSON.parse(jqXHR.responseText).fields
    if (fieldsWithErrors) {
      for (const f in fieldsWithErrors) {
        if (Object.hasOwnProperty.call(fieldsWithErrors, f)) {
          $('#' + f).closest('.field')
          $('#' + f)
            .popup({
              html: fieldsWithErrors[f].join(),
              on: 'manual',
              closable: false,
              variation: 'tiny',
            })
            .popup('show')
        }
      }

      _result = true
    }

    return _result
  },
  /**
   * Prevents paste of something that does not validate according to the
   * pattern attribute of that element. If no pattern is set on input element,
   * the behavior is defaulting to preventing non-numeric input to be pasted in
   * a numeric ONLY field
   * @param {ClipboardEvent} $event
   */
  preventPaste($event) {
    // 99% of the time pattern is a btoa (base64 encrypted string)
    let _pattern = $event.target.pattern
      ? window.atob($event.target.pattern)
      : CONSTANTS.REGEX_ONLY_NUMERIC

    // IE 11 $event.clipboardData is undefined
    let textToPaste = ($event.clipboardData || window.clipboardData).getData(
      'Text',
    )
    let rxValidText = new RegExp(_pattern)

    if (!rxValidText.test(textToPaste)) {
      $event.preventDefault()
    }
  },
  isNumberOnKeypress: function ($event) {
    $event = $event ? $event : window.event
    var charCode = $event.which ? $event.which : $event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      $event.preventDefault()
    } else {
      return true
    }
  },
  isAlphaNumericOnKeypress: function ($event) {
    $event = $event ? $event : window.event
    var charCode = $event.which ? $event.which : $event.keyCode
    if (
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122)
    ) {
      return true
    } else {
      $event.preventDefault()
    }
  },
  scrollGridToTop($refs, gridName) {
    let grid = $refs[gridName] ? $refs[gridName].instance : null
    if (!grid) return

    this.scrollGridTo(grid, 1)
  },
  scrollGridToEnd($refs, gridName) {
    let grid = $refs[gridName] ? $refs[gridName].instance : null
    if (!grid) return

    this.scrollGridTo(grid, 0)
  },
  scrollGridTo(grid, top = 1) {
    let scrollView = grid.getScrollable()
    scrollView.scrollTo(top ? 0 : scrollView.scrollHeight())
  },
  scrollGridToElement(grid, selector) {
    let scrollView = grid.getScrollable()
    scrollView.scrollToElement($(selector))
  },
  scrollToElem(selector) {
    $('html, body').animate(
      {
        scrollTop: $(selector)?.offset()?.top,
      },
      2000,
    )
  },
  getFileExtensionFromFileName(fileName) {
    if (!fileName) return null
    return fileName.slice(-5).split('.')[1].toLowerCase()
  },
}

export default utils
